import { render } from "./BattleScene.vue?vue&type=template&id=751c72ca&scoped=true"
import script from "./BattleScene.vue?vue&type=script&lang=js"
export * from "./BattleScene.vue?vue&type=script&lang=js"

import "./BattleScene.vue?vue&type=style&index=0&id=751c72ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-751c72ca"]])

export default __exports__